import { render, staticRenderFns } from "./xyList.vue?vue&type=template&id=71d14201&scoped=true&"
import script from "./xyList.vue?vue&type=script&lang=js&"
export * from "./xyList.vue?vue&type=script&lang=js&"
import style0 from "./xyList.vue?vue&type=style&index=0&id=71d14201&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d14201",
  null
  
)

export default component.exports